var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4172 64.9952C26.4172 72.6854 34.7545 77.4918 41.4244 73.6468C44.5199 71.8622 46.4268 68.5642 46.4268 64.9952C46.4268 57.305 38.0895 52.4986 31.4196 56.3438C28.3241 58.1282 26.4172 61.4262 26.4172 64.9952Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4269 65.0071V25H49.2855C62.7043 25 73.5828 34.5156 73.5828 46.2538",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.ce87cd0334a3808fb5c970286d5701bc.svg";
export { ForwardRef as ReactComponent };